import { Tenant } from 'src/types/enums';

import { Product } from '../billing/billing.types';
import { User } from '../organisation/organisation.types';
import { UserRole } from '../organisation/organisation.enum';

export interface RequestEmailVerificationDTO {
  email: string;
}

export interface CompletePasswordResetDTO {
  code: string;
  password: string;
}

export interface CreateAccountDTO {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
  tenant_type: Tenant;
  terms_id: string;
  timezone: string;
  recaptcha_token: string;
}

export interface AuthContext {
  user: Pick<User, 'id' | 'email' | 'email_verified'> & {
    status: AccountStatus;
    system_role: string;
    name: string;
  };
  account: Account;
  organization: Organization;
}

export interface Account {
  id: string;
  status: AccountStatus;
  type: Tenant;
  org_role: UserRole;
  onboarding_context: {
    [key: string]: boolean;
  };
}

export interface Organization {
  id: string;
  status: AccountStatus;
  type: Tenant;
  products: Product[];
}

export enum AccountStatus {
  active = 'active',
  inactive = 'inactive',
  locked = 'locked',
}

export interface LoginDTO {
  username: string;
  password: string;
  recaptcha_token?: string;
}

export interface RegisterInviteDTO {
  first_name: string;
  last_name: string;
  password: string;
  timezone: string;
  terms_id: string;
  invite_token: string;
}
